<template>
  <el-row :gutter="10">
    <el-col :span="14">
      <InspectionTable :orderCode="orderCode" />
    </el-col>
    <el-col :span="10">
      <DocTable :orderCode="orderCode" />
    </el-col>
  </el-row>
</template>
<script>
import InspectionTable from './components/inspection-table'
import DocTable from './components/doc-table'
export default {
  components: { InspectionTable, DocTable },
  props: { orderCode: { type: String, default: '' } },
}
</script>
